<p>show-review works!</p>
<p>{{ (item | async)?.bottle_name }}</p>
